import React from 'react';
import loadable from '@loadable/component';

const Overlay = loadable(() => import(/* webpackChunkName: "OverlayPopup" */ '/src/components/Widget/OverlayPopup'));

// The modal of the data export (Bootstrap markup, opened and closed by its owner): the title, the body, the footer (the Send button) and the
// overlay shown while a request is processed. Shared by DataExportPopup and MultiViewDataExportPopup.
export default function DataExportModal({ isOpen, isVisible, isProcessing, onClose, footer, children }) {
    return (
        <>
            <div className={`modal fade pr-0 ${isVisible ? 'show' : ''}`} id="dataExportModal" style={{ display: isOpen ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="dataExportModal-label" aria-hidden={!isOpen}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        {/* modal header */}
                        <div className="modal-header">
                            <h5 className="modal-title" id="dataExportModal-label">
                                Data Export Request
                            </h5>
                            <button
                                className="close"
                                type="button"
                                aria-label="Close"
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {/* modal body */}
                        <div className="modal-body" style={{ fontSize: '1rem' }}>
                            {children}
                        </div>

                        {/* modal footer */}
                        <div className="modal-footer">
                            {footer}
                        </div>

                    </div>
                </div>

                {isProcessing && <Overlay />}
            </div>
            {isOpen && <div className="modal-backdrop fade show"></div>}
        </>
    );
}
